import { render, staticRenderFns } from "./ByggnadsinvMap.vue?vue&type=template&id=69130142&"
import script from "./ByggnadsinvMap.vue?vue&type=script&lang=js&"
export * from "./ByggnadsinvMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports